import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=55b9af4d"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=55b9af4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmCountDown: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCountDown.vue').default,TlmChip: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmChip.vue').default,FallbackImage: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/FallbackImage.vue').default,TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default,ProductColorPicker: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Product/ColorPicker.vue').default})
